import { render, staticRenderFns } from "./Platform.vue?vue&type=template&id=07450c82&scoped=true"
import script from "./Platform.vue?vue&type=script&lang=js"
export * from "./Platform.vue?vue&type=script&lang=js"
import style0 from "./Platform.vue?vue&type=style&index=0&id=07450c82&prod&lang=scss&scoped=true"
import style1 from "./Platform.vue?vue&type=style&index=1&id=07450c82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07450c82",
  null
  
)

export default component.exports